import React from "react";
import { track } from "../../utils/analytics";
import { withRetryTime } from "../../api";

/**
 * Signup CTA for the public /reader page, shown when a free-tier daily limit
 * is hit (kind "ocr" | "translate") or as a standing banner (kind "banner").
 * Styled after TypingUpsell/IrabUpsell.
 */
export default function ReadingUpsell({ kind = "banner", retryAt = null, context = "public" }) {
  const hasToken = !!localStorage.getItem("token");
  const headline =
    kind === "ocr" ? "You've used today's free page scans"
    : kind === "translate" ? "You've used today's free translations"
    : "Reading a whole book?";
  const body =
    kind === "banner"
      ? "Create a free account to save your library, resume where you left off on any device, and get much higher daily limits."
      : withRetryTime(
          "Start your free trial and keep going instantly — much higher daily limits, and your library saved across devices.",
          retryAt
        );
  const go = () => {
    track("reader-signup-click", { context, kind });
    window.location.assign(hasToken ? "/" : "/?signup=1");
  };

  return (
    <div
      className="px-4 py-3 rounded-xl shrink-0 flex flex-col sm:flex-row sm:items-center gap-3"
      style={{ background: "var(--tag-violet-bg)", border: "1px solid var(--panel-line)" }}
    >
      <div className="flex-1">
        <p className="text-sm font-semibold text-dt-parchment">{headline}</p>
        <p className="text-xs text-dt-parchment-dim mt-0.5">{body}</p>
      </div>
      <button
        onClick={go}
        className="shrink-0 px-4 py-2 rounded-xl bg-dt-gold text-dt-ink hover:brightness-105 text-sm font-semibold transition-[filter]"
      >
        Start your 7-day free trial
      </button>
    </div>
  );
}
